const REFRESH_LOCK_NAME = "maqmailing-token-refresh";
const MAX_REFRESH_TOKEN_ATTEMPTS = 3;

export function withRefreshLock(callback) {
  if (typeof navigator !== "undefined" && navigator.locks?.request) {
    return navigator.locks.request(REFRESH_LOCK_NAME, callback);
  }
  return callback();
}

export async function refreshWithLatestToken(requestRefresh) {
  const attemptedTokens = new Set();
  let lastError = null;

  for (let attempt = 0; attempt < MAX_REFRESH_TOKEN_ATTEMPTS; attempt += 1) {
    const refreshToken = localStorage.getItem("refresh_token");
    if (!refreshToken || attemptedTokens.has(refreshToken)) break;
    attemptedTokens.add(refreshToken);

    try {
      return await requestRefresh(refreshToken);
    } catch (refreshError) {
      refreshError.attemptedRefresh = refreshToken;
      lastError = refreshError;
    }
  }

  if (lastError) throw lastError;
  return null;
}
